import { IAppState } from 'models/store.model'
import { DEFAULT_CURRENCY, TimeInterval } from 'root-constants'
import {
  ISubscription,
  TPriceId,
  TTrialPriceId,
} from 'models/subscriptions.model'

export const selectSubscriptionPriceId = (state: IAppState): TPriceId =>
  state.payment.selectedSubscription?.priceId || ''
export const selectSubscriptionPeriodQuantity = (
  state: IAppState,
): number | null => state.payment.selectedSubscription?.periodQuantity || null
export const selectSubscriptionPeriodName = (
  state: IAppState,
): TimeInterval | null => state.payment.selectedSubscription?.periodName || null
export const selectSubscription = (state: IAppState): ISubscription | null =>
  state.payment.selectedSubscription || null
export const selectSubscriptionCurrentPrice = (state: IAppState): number =>
  state.payment.selectedSubscription?.currentPrice || 0
export const selectSubscriptionOldPrice = (state: IAppState): number =>
  state.payment.selectedSubscription?.oldPrice || 0
export const selectSubscriptionCustomPrice = (state: IAppState): number =>
  state.payment.selectedSubscription?.customPrice || 0
export const selectSubscriptionCustomInterval = (
  state: IAppState,
): TimeInterval | null =>
  state.payment.selectedSubscription?.customPriceInterval || null
export const selectSubscriptionTrialPriceId = (
  state: IAppState,
): TTrialPriceId | null =>
  state.payment.selectedSubscription?.trialPriceId || null
export const selectSubscriptionTrialPeriodPrice = (state: IAppState): number =>
  state.payment.selectedSubscription?.trialCurrentPrice || 0
export const selectSubscriptionTrialPeriodDays = (state: IAppState): number =>
  state.payment.selectedSubscription?.trialPeriodDays || 0
export const selectProductId = (state: IAppState): string =>
  state.payment.selectedSubscription?.product || ''
export const selectSubscriptionFullPrice = (state: IAppState): number =>
  state.payment.selectedSubscription?.fullPrice || 0
export const selectSubscriptionDiscountAmount = (state: IAppState): number =>
  state.payment.selectedSubscription?.discountAmount || 0
export const select3DSecureIframeUrl = (state: IAppState): string =>
  state.payment.threeDSecureIframeURL
export const selectPaymentClientSecret = (state: IAppState): string =>
  state.payment.paymentClientSecret
export const selectTrialPeriodDays = (state: IAppState): number =>
  state.payment.trialPeriodDays
export const selectSubscriptionId = (state: IAppState): string =>
  state.payment.subscriptionId
export const selectPayPalPlanId = (state: IAppState): string =>
  state.payment.selectedSubscription?.paypalPlanId || ''
export const selectCurrency = (state: IAppState): string =>
  state.payment.selectedSubscription?.currency || DEFAULT_CURRENCY
